import classNames from 'classnames';
import { useState } from 'react';
import Button from '../../components/Button';
import { useCarInsuranceCentralModal } from '../../components/CarInsurance/WhatsappStickyModule';
import Close from '../../components/icons/Close';
import Whatsapp from '../../components/icons/Whatsapp';
import { usePinnedBottomHeight } from '../../hooks/usePinnedBottomHeight';
import { ComponentContactUsProps } from './types';

export const WhatsappStickyModule: React.FC<ComponentContactUsProps> = ({
  title,
  button_text,
  vertical,
  pushDataLayer,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  // What the bar covers while it is shown, for the Sort & Filter button and rail
  // to stay clear of it.
  const [bar, setBar] = useState<HTMLDivElement | null>(null);
  usePinnedBottomHeight(bar, isVisible);
  const { openModal } = useCarInsuranceCentralModal(vertical);

  const handleButtonClick = () => {
    if (pushDataLayer) {
      pushDataLayer({
        event: 'navigate',
        component_type: 'overlay',
        component_title: 'CTA_Contact us',
        action: 'click',
        index: '',
      });
    }

    openModal();
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div>
      <div
        ref={setBar}
        className={classNames(
          'fixed inset-x-0 bottom-0 z-30 translate-y-0 scale-100 pb-2 opacity-100 transition duration-500 ease-out sm:pb-5',
          !isVisible ? 'hidden' : '',
        )}
      >
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value -- because these sizes can not be set usign tailwind classes */}
        <div className="mx-auto w-82 md:w-[720px] lg:w-[800px] xl:w-[900px] 2xl:w-[1000px]">
          <div className="rounded-2xl p-3 shadow-lg bg-green-50 lg:rounded-3xl lg:p-4">
            <div className="flex flex-wrap items-start justify-between gap-2 sm:gap-4 md:items-center">
              {/* eslint-disable-next-line tailwindcss/no-arbitrary-value -- because the color is not in the palette*/}
              <div className="flex size-8 items-center justify-center rounded-full bg-[#25D366] md:size-12">
                <Whatsapp className="size-4 text-white md:size-6" />
              </div>
              <div className="flex flex-1 flex-col items-start gap-1 sm:w-0 sm:gap-2 md:flex-row md:items-center md:gap-4 lg:gap-6">
                <p className="mhg-alpha-typography-body-2 text-gray-900">
                  {title}
                </p>
                <Button
                  variant="text"
                  className="mhg-alpha-typography-button-1 shrink-0 cursor-pointer p-0 uppercase text-green-800 hover:text-green-800"
                  onClick={handleButtonClick}
                >
                  {button_text}
                </Button>
              </div>
              <div onClick={handleClose} role="button" tabIndex={0}>
                <Close className="mr-0 size-6 text-gray-600 md:mr-4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
